import { useEffect } from "react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
const isDev = import.meta.env.DEV;
const nodeEnv = import.meta.env.MODE;

function isLocalhost() {
  if (typeof window === "undefined") return false;
  const h = window.location.hostname;
  return h === "localhost" || h === "127.0.0.1" || h === "::1" || h === "[::1]";
}

const shouldInitSentry =
  sentryDsn &&
  (nodeEnv === "development" || nodeEnv === "production") &&
  !isLocalhost();

// Development / production builds only; never send events when opened on localhost
if (shouldInitSentry) {
  import("@sentry/react").then((Sentry) => {
    Sentry.init({
      dsn: sentryDsn,
      environment: import.meta.env.MODE,
      integrations: [
        Sentry.reactRouterV6BrowserTracingIntegration({
          useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes,
        }),
        Sentry.replayIntegration(),
      ],
      tracesSampleRate: isDev ? 0.2 : 1.0,
      tracePropagationTargets: [/^\//, /^https:\/\/yourserver\.io\/api/],
      replaysSessionSampleRate: isDev ? 0.1 : 0.1,
      replaysOnErrorSampleRate: 1.0,
    });
  });
}
